<template>
  <div>
      메인2222
      <router-link to="/about">about</router-link>
      <pre>


      </pre>
  </div>
</template>


<script>
export default {
  data() {
    return {
      canHistory : null
    }
  },
}
</script>